import styled from "styled-components";

const Wrapper = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1a1a 50%, #0a0e27 100%);
  position: relative;
  padding: 2rem 1rem;

  /* Add subtle animated background pattern */
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
        circle at 20% 50%,
        rgba(28, 91, 152, 0.05) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(80, 191, 255, 0.05) 0%,
        transparent 50%
      );
    pointer-events: none;
    z-index: 0;
  }

  .login-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 450px;
    position: relative;
    z-index: 1;
  }

  .login-logo {
    margin-bottom: 2rem;
    animation: fadeIn 0.6s ease-in-out;
  }

  .logo {
    display: block;
    margin: 0 auto;
    width: 12rem;
    height: auto;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
  }

  .form {
    width: 100%;
    background: rgba(28, 91, 152, 0.15);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 2px solid rgba(80, 191, 255, 0.2);
    border-radius: 24px;
    padding: 2.5rem 2rem;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 40px rgba(80, 191, 255, 0.1);
    animation: slideUp 0.6s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h3 {
    text-align: center;
    color: #ffffff;
    font-size: 1.75rem;
    font-weight: 600;
    margin-bottom: 2rem;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }

  .form-row {
    margin-bottom: 1.5rem;
  }

  label {
    color: #ffffff;
    font-weight: 500;
    margin-bottom: 0.75rem;
    display: block;
    font-size: 0.95rem;
  }

  input {
    width: 100%;
    padding: 1rem 1.25rem;
    border-radius: 14px;
    border: 2px solid rgba(80, 191, 255, 0.25);
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    color: #ffffff;
    font-size: 1rem;
    transition: all 0.3s ease;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
      outline: none;
      border-color: var(--brand-light-blue);
      background: rgba(255, 255, 255, 0.12);
      box-shadow: 0 0 0 3px rgba(80, 191, 255, 0.15),
        inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn {
    width: 100%;
    margin-top: 0.75rem;
    padding: 1.125rem 1.5rem;
    background: linear-gradient(
      135deg,
      var(--brand-light-blue) 0%,
      #1c5b98 100%
    );
    border: none;
    border-radius: 14px;
    color: #ffffff;
    font-size: 1.05rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 6px 20px rgba(80, 191, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(80, 191, 255, 0.5);
    }

    &:active:not(:disabled) {
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  }

  p {
    margin: 1.5rem 0 0;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.95rem;
  }

  .member-btn {
    background: transparent;
    border: none;
    color: var(--brand-light-blue);
    cursor: pointer;
    font-weight: 600;
    padding: 0 0.25rem;
    transition: all 0.2s ease;
    text-decoration: none;

    &:hover {
      color: #50bfff;
      text-decoration: underline;
    }
  }

  /* Alert styling to match theme */
  .alert {
    background: rgba(255, 107, 107, 0.15);
    border: 2px solid rgba(255, 107, 107, 0.4);
    border-radius: 12px;
    padding: 0.875rem 1rem;
    margin-bottom: 1.5rem;
    color: #ff6b6b;
    font-size: 0.95rem;
    text-align: center;
    backdrop-filter: blur(10px);
  }

  .alert-success {
    background: rgba(80, 191, 255, 0.15);
    border-color: rgba(80, 191, 255, 0.4);
    color: var(--brand-light-blue);
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    padding: 1rem;

    .form {
      padding: 2rem 1.5rem;
    }

    h3 {
      font-size: 1.5rem;
    }
  }
`;

export default Wrapper;
